module.exports = __webpack_public_path__ + "static/media/Pedro - copia.53d7b1ab.jpg";